import React, { Fragment, useState } from 'react';
import { Combobox, Transition } from '@headlessui/react';
import { ChevronDown } from 'lucide-react';

// Select2-style searchable dropdown - typing filters the option list instead
// of just scrolling a long static one. Built on Headless UI's Combobox
// (the searchable counterpart to the plain Listbox this used to wrap) so
// every consumer of CustomSelect gets the search behavior for free.
const CustomSelect = ({ value, onChange, options, placeholder, className = '' }) => {
  const [query, setQuery] = useState('');
  const selectedOption = options.find((opt) => opt.value === value);

  const filteredOptions =
    query === ''
      ? options
      : options.filter((opt) =>
          opt.label.toLowerCase().includes(query.toLowerCase()),
        );

  return (
    <Combobox value={value} onChange={onChange}>
      <div className="relative w-full">
        <div className="relative">
          <Combobox.Input
            className={`px-4 py-3.5 w-full text-sm text-gray-700 bg-white rounded-full border border-gray-200 outline-none hover:bg-gray-50 focus:ring-2 focus:ring-emerald-500 ${className}`}
            displayValue={() => (query ? query : selectedOption ? selectedOption.label : '')}
            placeholder={placeholder}
            onChange={(e) => setQuery(e.target.value)}
          />
          <Combobox.Button className="flex absolute inset-y-0 right-0 items-center pr-4">
            <ChevronDown className="w-4 h-4 text-gray-500" aria-hidden="true" />
          </Combobox.Button>
        </div>

        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={() => setQuery('')}
        >
          <Combobox.Options className="overflow-auto absolute z-50 mt-1 w-full max-h-60 bg-white rounded-lg shadow-lg focus:outline-none">
            {filteredOptions.length === 0 && (
              <div className="px-4 py-3 text-sm text-gray-400">No matches</div>
            )}
            {filteredOptions.map((option) => (
              <Combobox.Option
                key={option.value}
                value={option.value}
                className={({ active, selected }) => `
                  relative cursor-pointer select-none
                  px-4 py-3 text-sm border border-b font-serif text-[#8E8E93]
                  ${active || selected ? 'bg-gray-100' : 'bg-white'}
                  ${selected ? 'font-medium' : 'font-normal'}
                `}
              >
                {option.label}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        </Transition>
      </div>
    </Combobox>
  );
};

export default CustomSelect;
